import { useTranslation } from 'react-i18next';
import { Shield, Cpu, Network } from 'lucide-react';

export default function LoginFeatures() {
  const { t } = useTranslation('auth');

  return (
    <div className="mt-8 pt-6 border-t border-white/10">
      <div className="grid grid-cols-3 gap-4 text-center">
        <div className="space-y-1">
          <div className="w-10 h-10 mx-auto rounded-lg bg-cyan-400/10 flex items-center justify-center">
            <Shield className="w-5 h-5 text-cyan-400" />
          </div>
          <p className="text-xs text-gray-400">{t('login.featureSecurity')}</p>
        </div>
        <div className="space-y-1">
          <div className="w-10 h-10 mx-auto rounded-lg bg-primary/10 flex items-center justify-center">
            <Cpu className="w-5 h-5 text-primary" />
          </div>
          <p className="text-xs text-gray-400">{t('login.featureInventory')}</p>
        </div>
        <div className="space-y-1">
          <div className="w-10 h-10 mx-auto rounded-lg bg-cyan-400/10 flex items-center justify-center">
            <Network className="w-5 h-5 text-cyan-400" />
          </div>
          <p className="text-xs text-gray-400">{t('login.featureAnalysis')}</p>
        </div>
      </div>
    </div>
  );
}
